module.exports = __webpack_public_path__ + "static/media/south-africa-flag-square-medium.396b0277.png";